import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux"; // Zum Abrufen der user_id aus dem Redux-Store
import "./Support.css"; // Dein CSS für das Styling

const SendMessage = () => {
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [statusMessage, setStatusMessage] = useState("");
  const [userData, setUserData] = useState({});
  const userId = useSelector((state) => state.user.user_id); // user_id aus dem Redux-Store

  // Benutzerdaten aus der API abrufen
  const fetchUserData = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/getuserbyid/${userId}`);
      const data = await response.json();
      setUserData(data);
      console.log("Benutzerdaten:", data);
    } catch (error) {
      console.error("Fehler beim Abrufen der Benutzerdaten:", error);
    }
  };

  useEffect(() => {
    if (userId) {
      fetchUserData();
    }
  }, [userId]);

  // Funktion zum Senden der Nachricht
  const handleSendMessage = async (e) => {
    e.preventDefault();

    if (!subject || !message) {
      setStatusMessage("Bitte fülle alle Felder aus.");
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/send-email`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          user_id: userId, // user_id aus dem Redux-Store
          name: userData.name,
          lastname: userData.lastname,
          email: userData.email,
          subject,
          message,
        }),
      });

      if (response.ok) {
        setStatusMessage("Nachricht wurde erfolgreich gesendet!");
        setSubject("");
        setMessage("");
      } else {
        setStatusMessage("Fehler beim Senden der Nachricht.");
      }
    } catch (error) {
      console.error("Fehler beim Senden der Nachricht:", error);
      setStatusMessage("Fehler beim Senden der Nachricht.");
    }
  };

  return (
    <div className="send-message-container">
      <h2>Nachricht senden</h2>
      {statusMessage && <p className="status-message">{statusMessage}</p>}

      <form onSubmit={handleSendMessage}>
        <div className="form-group">
          <label>Betreff:</label>
          <input
            type="text"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            placeholder="Betreff eingeben"
            required
          />
        </div>

        <div className="form-group">
          <label>Nachricht:</label>
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Nachricht eingeben"
            rows="5"
            required
          />
        </div>

        {userData && (
          <div className="user-info">
            <p><strong>User ID:</strong> {userId}</p>
            <p><strong>Name:</strong> {userData.name} {userData.lastname}</p>
            <p><strong>Email:</strong> {userData.email}</p>
          </div>
        )}

        <button type="submit" className="submit-button">Nachricht senden</button>
      </form>
    </div>
  );
};

export default SendMessage;
